import axiosInstance from '../services/AxiosInstance';

export const getAccessKeySettings = async () => {
  const response = await axiosInstance.get("access-key-settings"); // Adjust as needed
  return response.data;
};

export const saveAccessKeySettings = async (data) => {
  const response = await axiosInstance.put("access-key-settings/1", data); // Or PUT if updating
  return response.data;
};

export const formatError = (errorData) => {
  return errorData.message || "An unexpected error occurred.";
};